module.exports = __webpack_public_path__ + "img/amy-ava.ad612ea.png";